import { apiClient } from "../../../../lib/api-client";
import { useMutation } from '@tanstack/react-query';
import { SecurityAnswer } from "../types/SecurityAnswer";
import { ChangePasswordResult } from "../types/ChangePasswordResult";

export const useChangeSecurityAnswerMutation = () => useMutation({
    mutationFn: async (answer: SecurityAnswer) => {
        try {
            let data: ChangePasswordResult = await apiClient.post("my-account/change-security-answer", {
                securityQuestionID: answer.securityQuestionID,
                answer: answer.answer
            });

            return {
                isOk: data.isSuccess,
                message: data.errorMessage
            };
        } catch {
            return {
                isOk: false,
                message: "Failed to change password"
            };
        }
    },
})

